import {
  WizardBody,
  WizardBodyList,
  WizardButton,
  WizardButtonList,
  WizardContent,
} from '../../../ui/wizard/wizard-content';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import { RoutingPath } from '../../../../routes/routing-path';

type Props = {}

export const Step4StaffPasswordResetWizard = (props: Props) => {
  const dispatch = useDispatch();
  return (
    <WizardContent>
      <WizardBodyList>
        <WizardBody
          body={['パスワードを変更しました。']}
        />
      </WizardBodyList>
      <WizardButtonList>
        <WizardButton
          label="閉じる"
          onClick={() => dispatch(push(RoutingPath.staffLogin))}
        />
      </WizardButtonList>
    </WizardContent>
  );
};